import * as React from "react";

import LoginForm, { LoginFormValues } from "./LoginForm";

export interface LoginProps {
  isError: boolean;
  formMsg?: string;
  handleSubmit: (values: LoginFormValues) => void;
}

const Login = (props: LoginProps) => (
  <div className="login-form">
    <h4 className="login-form__heading">Đăng nhập vào tài khoản của bạn</h4>
    <LoginForm onSubmit={props.handleSubmit} />
    {props.isError && <p className="login-form__error">{props.formMsg}</p>}
  </div>
);

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Account/components/Login.tsx